import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { Heart } from 'lucide-react';

const RomancePage = () => (
  <ServicePageTemplate
    translationPrefix="romancePage"
    icon={Heart}
    color="from-pink-500 to-pink-600"
    accentColor="bg-pink-50 border border-pink-200"
  />
);

export default RomancePage;
